import { CoasCarrousel } from "../components/coas_carrousel";
import { UCarlingCarrouselConfig, URematchCarrouselConfig, } from "../utilities/carousel.utils";
import { TimeLineComponent } from "../components/timeline.component";
import { TabsComponent } from "../components/tabs.component";
class CarlingPage {
    constructor() {
        this.carlingCarouselSelector = ".carlingCarouselSelector";
        this.timeLineSelector = ".timelineContainerSelector";
        this.rematchCarrouselSelector = ".rematchCarrouselSelector";
        this.tabsCarlingCupId = "tabsCarlingCupId";
        this.dateSumtitleId = "dateSubtitle";
        this.handlerCarlingCarrousel = (carrouselSelector) => {
            const carrousel = document.querySelectorAll(carrouselSelector);
            console.log("handlerCarlingCarrousel : ", carrousel);
            if (!carrousel)
                return;
            carrousel.forEach((itemCarrousel) => {
                const carrouselId = itemCarrousel.getAttribute("id");
                console.log("ID handlerCarlingCarrousel: ", carrouselId);
                if (carrouselId) {
                    const carrousel = new CoasCarrousel(carrouselId, UCarlingCarrouselConfig, () => {
                        this.eventShowDateASSubtitle(carrouselId);
                    });
                    carrousel.onInit();
                    this.eventShareCard(carrouselId);
                }
            });
        };
        this.handlerRematchCarrousel = (carrouselSelector) => {
            const carrousel = document.querySelectorAll(carrouselSelector);
            console.log("handlerRematchCarrousel : ", carrousel);
            if (!carrousel)
                return;
            carrousel.forEach((itemCarrousel) => {
                const carrouselId = itemCarrousel.getAttribute("id");
                console.log("ID handlerRematchCarrousel: ", carrouselId);
                if (carrouselId) {
                    const carrousel = new CoasCarrousel(carrouselId, URematchCarrouselConfig);
                    carrousel.onInit();
                }
            });
        };
        this.handlerTimeLines = (timeLinesSelector) => {
            const timelines = document.querySelectorAll(timeLinesSelector);
            console.log("handlerTimeLines : ", timelines);
            if (!timelines)
                return;
            timelines.forEach((itemTimeLine) => {
                const timeLineId = itemTimeLine.getAttribute("id");
                console.log("ID handlerTimeLines: ", timeLineId);
                if (timeLineId) {
                    const timeLine = new TimeLineComponent(timeLineId);
                    timeLine.onInit();
                }
            });
        };
        this.eventShareCard = (carrouselId) => {
            console.log("------------1 Carrousel idi : ", carrouselId);
            const carlingPageCarrousel = document.getElementById(carrouselId);
            console.log("------------2 Carrousel idi : ", carlingPageCarrousel);
            const lsShareBtn = carlingPageCarrousel === null || carlingPageCarrousel === void 0 ? void 0 : carlingPageCarrousel.querySelectorAll(".btn-shared");
            console.log("------------3 Carrousel idi : ", lsShareBtn);
            lsShareBtn === null || lsShareBtn === void 0 ? void 0 : lsShareBtn.forEach((btnShare) => {
                btnShare.addEventListener("click", () => {
                    const link = btnShare.getAttribute("shareLink") || "";
                    navigator.clipboard.writeText(link);
                    const tooltip = btnShare.previousElementSibling;
                    console.log("Tolto : value : ", tooltip);
                    tooltip === null || tooltip === void 0 ? void 0 : tooltip.classList.add('!opacity-100');
                    const mytimeout = setTimeout(() => {
                        tooltip === null || tooltip === void 0 ? void 0 : tooltip.classList.remove("!opacity-100");
                        clearTimeout(mytimeout);
                    }, 2000);
                }, { passive: true });
            });
        };
        this.eventShowDateASSubtitle = (carrouselId) => {
            var _a;
            const subtitleContainer = document.getElementById(this.getSubtitleId(carrouselId));
            const carlingPageCarrousel = document.getElementById(carrouselId);
            const subtitleContent = (_a = carlingPageCarrousel === null || carlingPageCarrousel === void 0 ? void 0 : carlingPageCarrousel.querySelector(".glide__slide--active>p")) === null || _a === void 0 ? void 0 : _a.innerHTML;
            subtitleContainer &&
                subtitleContent &&
                (subtitleContainer.innerHTML = subtitleContent);
        };
        this.getSubtitleId = (carrouselId) => {
            const part = carrouselId.split("-")[0];
            return carrouselId.replace(part, "subtitle");
        };
        console.log("START LANDING PAGE ....");
        this.initPageConfig();
    }
    initPageConfig() {
        this.handlerTimeLines(this.timeLineSelector);
        this.handlerCarlingCarrousel(this.carlingCarouselSelector);
        this.handlerRematchCarrousel(this.rematchCarrouselSelector);
        const tabsCarlingCup = document.getElementById(this.tabsCarlingCupId);
        if (tabsCarlingCup) {
            const carlingTabs = new TabsComponent(this.tabsCarlingCupId, undefined, false);
            carlingTabs.onInit();
        }
    }
}
window.addEventListener("load", function () {
    new CarlingPage();
});
